var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BgImage',{staticClass:"logo",attrs:{"image":"logo"}},[_c('div',{staticClass:"c-logo-title",domProps:{"innerHTML":_vm._s(_vm.tl(_vm.$t('landingpage-freelancer.title'), true))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }